import type { ProjectScope } from './project-scope';

type BlockingPendingCollection = 'blocking' | 'choreography';

const pendingBlockingWriteKeys = new Set<string>();

function blockingWriteKey(scope: ProjectScope, collection: BlockingPendingCollection, id: string): string {
    return `${scope.orgId}\0${scope.projectId}\0${collection}\0${id}`;
}

function markPendingBlockingWrite(scope: ProjectScope, collection: BlockingPendingCollection, id: string): void {
    pendingBlockingWriteKeys.add(blockingWriteKey(scope, collection, id));
}

function clearPendingBlockingWrite(scope: ProjectScope, collection: BlockingPendingCollection, id: string): void {
    pendingBlockingWriteKeys.delete(blockingWriteKey(scope, collection, id));
}

function isPendingBlockingWrite(scope: ProjectScope, collection: BlockingPendingCollection, id: string): boolean {
    return pendingBlockingWriteKeys.has(blockingWriteKey(scope, collection, id));
}

export function markPendingBlockingPathWrite(scope: ProjectScope, id: string): void {
    markPendingBlockingWrite(scope, 'blocking', id);
}

export function clearPendingBlockingPathWrite(scope: ProjectScope, id: string): void {
    clearPendingBlockingWrite(scope, 'blocking', id);
}

export function isPendingBlockingPathWrite(scope: ProjectScope, id: string): boolean {
    return isPendingBlockingWrite(scope, 'blocking', id);
}

export function markPendingChoreographyWrite(scope: ProjectScope, id: string): void {
    markPendingBlockingWrite(scope, 'choreography', id);
}

export function clearPendingChoreographyWrite(scope: ProjectScope, id: string): void {
    clearPendingBlockingWrite(scope, 'choreography', id);
}

export function isPendingChoreographyWrite(scope: ProjectScope, id: string): boolean {
    return isPendingBlockingWrite(scope, 'choreography', id);
}

export function clearPendingBlockingWrites(): void {
    pendingBlockingWriteKeys.clear();
}
